import { Project } from '../interfaces/project';
import { Module } from '../enums/module';

export class ModuleHelper {
  public static hasModule(project: Project, module: Module) {
    return project.enabledModules && project.enabledModules.includes(module);
  }
}
